import React from 'react';
import { isEmpty } from 'lodash';

import ListItem from '@material-ui/core/ListItem';

import styles from './Storyboard.module.scss';
import {
  MenuItem,
  Menu,
  IconButton,
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
export default class Storyboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {anchorEl: null};
  }

  render() {
    const open = Boolean(this.state.anchorEl);
    const handleClick = (event) => {
      this.setState({anchorEl : event.currentTarget});
    };
    const handleClose = () => {
      this.setState({anchorEl : null});
    };

    const { storyboard } = this.props;
    if (isEmpty(storyboard)) return null;   

    let borderColor = '#52A8EF';
    let borderStyle = 'none';
    let paddingRight,
      paddingBottom = '0px';

    if (this.props.highlight === storyboard.index) {
      borderColor = '#52A8EF';
      borderStyle = 'none';
      paddingRight = '18px';
      paddingBottom = '8px';
    }
    return (
      <div
        style={{
          borderColor,
          borderStyle,
          paddingRight,
          paddingBottom,
        }} 
      >
        <ListItem
          className={styles.root}  
        >
          <div className={styles.clue}>
            <div>{storyboard.name}</div>            
            <div>
            <IconButton  
              aria-label="more"
              id="long-button"
              aria-controls={open ? 'long-menu' : undefined}
              aria-expanded={open ? 'true' : undefined}
              aria-haspopup="true"
              style={{padding: '5px'}}
              onClick={handleClick}
              >
                <MoreVertIcon />
              </IconButton>
            <Menu 
              id="long-menu" 
              MenuListProps={{
                'aria-labelledby': 'long-button',
              }}
              anchorEl={this.state.anchorEl}
              open={open}
              onClose={handleClose}>
                <MenuItem 
                style={{color:"#434F69",fontFamily: 'gilroy-regular'}}
                 onClick={() => {this.props.onClickStoryboardFunc(storyboard);handleClose();}}>Edit</MenuItem>
                {/* <MenuItem 
                style={{color:"#434F69",fontFamily: 'gilroy-regular'}} 
                onClick={() => {
                  const confirm =window.confirm("Are you sure you want to delete this storyboard?")
                  if(confirm){
                    this.props.onDeleteStoryboardFunc(storyboard.id);handleClose();
                  }
                  }}>Remove</MenuItem> */}
                <MenuItem 
                style={{color:"#434F69",fontFamily: 'gilroy-regular'}} 
                onClick={() => {
                  const confirm =window.confirm("Are you sure you want to clone this storyboard?")
                  if(confirm){
                    this.props.onCloneStoryboardFunc(storyboard.id);handleClose();
                  }
                  }}>Clone</MenuItem>
            </Menu>
            </div>
          </div>
        </ListItem>
      </div>
    );
  }
}
